import type { ReactNode } from 'react'

import styles from '../advanced-search.module.css'

export function Layout ({ children }: { children: ReactNode }): JSX.Element {
  return (
    <div className={styles.layout}>{children}</div>
  )
}
